"use client";

import { c as _c } from "react/compiler-runtime";
import { isChannel } from "@website/utils/channel/helpers";
import { AgenciesButton } from "@website/widget/header/components/agencies/agencies-button";
import { BackButton } from "@website/widget/header/components/back/back-button";
import { Logo } from "@website/widget/header/components/logo/logo";
import { MyTrips } from "@website/widget/header/components/my-trips/my-trips";
import { SupportAgent } from "@website/widget/header/components/support-agent/support-agent";
import { TravelServicesMobileDrawer } from "@website/widget/header/components/travel-services/TravelServicesMobileDrawer";
import { TravelServicesDesktop } from "@website/widget/header/components/travel-services/travel-services-desktop";
import { HeaderLogin } from "@website/widget/header/header-login/header-login";
import { HeaderPropertiesType } from "@website/widget/header/header.types";
import { LoginModal } from "@website/widget/login";
import { Suspense } from "react";
export const Header = t0 => {
  const $ = _c(46);
  const {
    showBackButton: t1,
    isHomePage: t2,
    minimalView,
    hideBackButton,
    title,
    customTitle,
    minimalLogo,
    disableLogoURL: t3
  } = t0;
  const showBackButtonParameter = t1 === undefined ? false : t1;
  const isHomePage = t2 === undefined ? false : t2;
  const disableLogoURL = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = isChannel(["jek"]);
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const isJek = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = isChannel(["jek"]);
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const isAndroidOrWebApp = t5;
  const showBackButton = !hideBackButton && (showBackButtonParameter || isJek || isAndroidOrWebApp && !isHomePage);
  const showAppModeTitle = (isJek || isAndroidOrWebApp) && Boolean(title);
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = isChannel(["b2b", "website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const showAuth = t6;
  let t7;
  if ($[3] !== isHomePage) {
    t7 = !isChannel(["in-store"]) && isHomePage;
    $[3] = isHomePage;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const showSupportAgent = t7;
  let t8;
  if ($[5] !== minimalView) {
    t8 = !minimalView && isChannel(["website"]);
    $[5] = minimalView;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const showAgenciesButton = t8;
  let t9;
  if ($[7] !== minimalView) {
    t9 = !minimalView && isChannel(["website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[7] = minimalView;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const showMyTrips = t9;
  let t10;
  if ($[9] !== minimalView || $[10] !== showBackButton) {
    t10 = !minimalView && !showBackButton && isChannel(["website", "telesale", "web-app", "android", "safarmarket"]);
    $[9] = minimalView;
    $[10] = showBackButton;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const showTravelServices = t10;
  let t11;
  if ($[12] !== isHomePage || $[13] !== showBackButton) {
    t11 = showBackButton && <Suspense><BackButton isHomePage={isHomePage} /></Suspense>;
    $[12] = isHomePage;
    $[13] = showBackButton;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== showTravelServices) {
    t12 = showTravelServices && <TravelServicesMobileDrawer />;
    $[15] = showTravelServices;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== customTitle || $[18] !== disableLogoURL || $[19] !== minimalLogo || $[20] !== showAppModeTitle || $[21] !== title) {
    t13 = showAppModeTitle ? <div className="text-headline-6 font-normal">{title}</div> : <><Logo minimalLogo={minimalLogo} disableURL={disableLogoURL} />{Boolean(customTitle) && <><div className="bg-outline-thin -ms-1 me-1 h-[32px] w-px lg:-ms-2 lg:me-0 lg:h-[40px]" /><div className="text-on-surface-medium-emphasis text-sm font-bold lg:text-base">{customTitle}</div></>}</>;
    $[17] = customTitle;
    $[18] = disableLogoURL;
    $[19] = minimalLogo;
    $[20] = showAppModeTitle;
    $[21] = title;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== showTravelServices) {
    t14 = showTravelServices && <TravelServicesDesktop />;
    $[23] = showTravelServices;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== showAgenciesButton) {
    t15 = showAgenciesButton && <AgenciesButton />;
    $[25] = showAgenciesButton;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
    t16 = <nav className="flex h-full items-center gap-2 lg:gap-4">{t11}{t12}{t13}{t14}{t15}</nav>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex-1" />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== showMyTrips) {
    t18 = showMyTrips && <Suspense><MyTrips /></Suspense>;
    $[34] = showMyTrips;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== showSupportAgent) {
    t19 = showSupportAgent && <Suspense fallback={null}><SupportAgent /></Suspense>;
    $[36] = showSupportAgent;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = showAuth && <Suspense><HeaderLogin /></Suspense>;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t16 || $[40] !== t18 || $[41] !== t19) {
    t21 = <div className="mx-0 flex size-full items-center gap-2 lg:gap-4 xl:mx-auto xl:w-[1200px]">{t16}{t17}{t18}{t19}{t20}</div>;
    $[39] = t16;
    $[40] = t18;
    $[41] = t19;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Suspense><LoginModal /></Suspense>;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t21) {
    t23 = <div className="border-b-outline-thin relative z-30 flex h-16 w-full border-b bg-white px-4 lg:z-40 lg:px-6 xl:px-10">{t21}{t22}</div>;
    $[44] = t21;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  return t23;
};